import { Box, Typography, styled } from '@mui/material'
import HighestYear from 'assets/images/highest-year.png'
import DashboardUsageBg from 'assets/images/dashboard-usage-bg.png'
import UsageMonth from 'assets/images/usage-month.png'

import { color } from 'config/color'
import { type IDashboardStats } from 'containers/Dashboard/Dashboard'
import { formatValue } from 'utils'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'

interface IProps {
  dashboardStats: IDashboardStats
}
export const NumberStats = ({ dashboardStats }: IProps): JSX.Element => {
  const isMobile = useMobileBreakpoints()
  return (
    <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
      <Background image={DashboardUsageBg} p={3}>
        <Box display="flex" alignItems="center" gap={2}>
          <img src={UsageMonth} height={isMobile ? '57px' : '90px'} alt="" aria-hidden="true" />
          <Box>
            <Box display="flex" color={color.white} gap={1} alignItems="flex-end">
              <Typography fontSize={isMobile ? '32px' : '52px'}>{formatValue(`${dashboardStats.usageThisMonth}`, false, false)}</Typography>
              <Typography fontSize={isMobile ? 16 : 18} mb={isMobile ? 1 : 2}>{dashboardStats.uom}</Typography>
            </Box>
            <Typography variant="h2" fontSize={isMobile ? 12 : 16} color={color.secondary[500]} letterSpacing={1}>USAGE THIS MONTH</Typography>
          </Box>
        </Box>
      </Background >
      <Background image={DashboardUsageBg} p={3}>
        <Box display="flex" alignItems="center" gap={2}>
          <img src={HighestYear} height={isMobile ? 70 : 90} alt="" aria-hidden="true" />
          <Box>
            <Box display="flex" color={color.white} gap={1} alignItems="flex-end">
              <Typography fontSize={isMobile ? '32px' : '52px'}>{formatValue(`${dashboardStats.highestThisYear}`, false, false)}</Typography>
              <Typography fontSize={18} mb={isMobile ? 1 : 2}>{dashboardStats.uom}</Typography>
            </Box>
            <Typography variant="h2" fontSize={isMobile ? 12 : 16} color={color.secondary[500]} letterSpacing={1}>HIGHEST THIS YEAR</Typography>
          </Box>
        </Box>
      </Background >
    </Box >
  )
}

const Background = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'image'
})<{ image?: string }>(({ image }) => ({
  backgroundImage: `url(${image})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  borderRadius: '10px'
}))
